async function doGetShopifyProductData(handle = false) {
    return new Promise((resolve, reject) => {
        if (!handle) {
            reject({ code: 1, msg: 'Handle error' });
        }
        const url = 'products/' + handle + '.js';
        fetch(window.Shopify.routes.root + url)
            .then(response => {
                if (!response.ok) {
                    reject({ code: 1, msg: 'Network response was not ok' });
                }
                return response.json();
            }).then(data => {
                resolve({ code: 0, msg: 'success', data: data });
            }).catch((error) => {
                reject({ code: 1, msg: error });
            });
    });
}
async function doShopifyAddToCart(formData) {
    return new Promise((resolve, reject) => {
        fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        }).then((response) => {
            if (!response.ok) {
                reject({ code: 1, msg: 'Network response was not ok' });
            }
            resolve({ code: 0, msg: 'success', data: response.json() });
        }).catch((error) => {
            reject({ code: 1, msg: error });
        });
    });
}
async function doGetShopifyCartData() {
    return new Promise((resolve, reject) => {
        fetch(window.Shopify.routes.root + "cart.js", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => {
            if (!response.ok) {
                reject({ code: 1, msg: 'Network response was not ok' });
            }
            return response.json();
        }).then(data => {
            resolve({ code: 0, msg: 'success', data: data });
        }).catch((error) => {
            reject({ code: 1, msg: error });
        });
    });
}
async function doShowProductAddToCart(id = false, quantity = 1, checkout = true) {
    if (!id) {
        return false;
    };
    let formData = {
        'items': [{
            'id': id,
            'quantity': quantity
        }]
    };
    const addData = await doShopifyAddToCart(formData);
    if (addData.code == 0) {
        if (checkout) {
            window.location.href = '/checkout';
        } else {
            const cartData = await doGetShopifyCartData();
            if (cartData.code == 0) {
                const count = cartData.data.item_count || 0;
                doRenewShopifyCartCount(count);
            }
        }
    }
}

// renew shopify cart count
function doRenewShopifyCartCount(count = 0) {
    if (doCheckDomClass('wdshop-cart-count-now')) {
        const dom = document.querySelectorAll('.wdshop-cart-count-now');
        dom.forEach(function (element) {
            element.innerHTML = count;
        });
    } else {
        if (doCheckDomClass('wdshop-header-icon-cart')) {
            const cart_icon_dom = document.querySelector('.wdshop-header-icon-cart');
            cart_icon_dom.innerHTML += '<div class="wdshop-absolute wdshop-radius-9 wdshop-alignment wdshop-justify-center wdshop-header-cart-count wdshop-cart-count-now">' + count + '</div>';
        }
    }
}

// remove shopify cart item
function doRemoveShopifyCartItem(index = 0) {
}

// check dom class
function doCheckDomClass(dom = 'wdshop') {
    var hasClass = false;
    if (document.querySelector('.' + dom)) {
        hasClass = true;
    }
    return hasClass;
}

async function doShowProductInfo(id = false, handle = false, description = '') {
    if (!id || !handle) {
        return false;
    };
    const product = await doGetShopifyProductData(handle);
    doDisplayProduct(id, product.data, description);
}

function doDisplayProduct(id = false, data = false, description = '') {
    if (!id || !data) {
        return false;
    }
    const divBox = document.getElementById(id);
    let desc = '';
    if (description !== '') {
        desc = description;
    } else {
        desc = data.description;
    }
    divBox.innerHTML = '';
    let html = '';
    html += '<div class="wdshop-article-product-show">';
    html += '<div class="wdshop-article-product-show-pic"><a target="_blank" href="/products/' + data.handle + '">';
    html += '<img src="' + data.featured_image + '" />';
    html += '</a></div>';
    html += '<div class="wdshop-article-product-show-info">';
    html += '<div class="wdshop-article-product-show-h3">';
    html += data.title
    html += '</div>';
    html += '<div class="wdshop-article-product-show-price">$';
    html += data.price / 100
    html += '</div>';
    html += '<div class="wdshop-article-product-show-contant">';
    html += desc;
    html += '</div>';
    html += '<div class="wdshop-article-product-show-btnBox">';
    html += '<div class="wdshop-article-product-show-btn">';
    html += '<a target="_blank" href="/products/' + data.handle + '">Learn More</a>';
    html += '</div>';
    html += '<div class="wdshop-article-product-show-btn wdshop-article-product-show-btn-buy">';
    html += '<a href="javascript:void(0);" onclick="doShowProductAddToCart(' + "'" + data.variants[0].id + "'" + ')">Buy Now</a>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    divBox.innerHTML = html;
}